import React, { useState, useEffect } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { IoPersonSharp } from 'react-icons/io5'
import { IoIosCall } from 'react-icons/io'
import { MdCallEnd, MdDialpad } from 'react-icons/md'
import { AiOutlinePauseCircle, AiOutlinePlayCircle } from 'react-icons/ai'
import { BsMicMuteFill, BsSoundwave } from 'react-icons/bs'
import '../../../styles/components/common/_inBoundCallComponent.scss'
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import { toast } from '../ToastComponent/toast'
import { holdCall, unholdCall, getRecentCallsAndVoicemails, linkVoicemailToVendor, shareCall, getVoicemails, getMediaData, getRecordingUrl } from '../../../redux/actions/caller'
import { RiDeleteBack2Fill } from 'react-icons/ri'
import { RxCounterClockwiseClock } from 'react-icons/rx'
import { IoRecordingOutline } from 'react-icons/io5'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import { CiMaximize1, CiMinimize1 } from 'react-icons/ci'
import { BsInfoCircle } from 'react-icons/bs'
import { BiUnlink } from 'react-icons/bi'
import { FiLink2, FiShare } from 'react-icons/fi'
import { HiPhoneIncoming, HiPhoneOutgoing, HiPhoneMissedCall } from 'react-icons/hi'
import moment from 'moment'
import { Loader } from 'rsuite'
import AudioPlayer from 'react-h5-audio-player';
import Select from 'react-select'
import QaNotesModal from '../../QualityComponent/modals/qa-notes-modal'
import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { parsePhoneNumber } from 'awesome-phonenumber'

const DialerComponent = ({ vendorData, onCallStartClick, onCallEndClick, callSID, status, isCallDial, dialerClass, call, callStartTime, callsTableData, vendorId, supPhoneNumber = '', removeSupPhoneNumber }) => {
    const dispatch = useDispatch()
    const store = useStore().getState()
    const {
        auth: { user },
        caller: { twilioDevice }
    } = store
    const dialerNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, '*', 0, '#']
    const callHistoryTabs = [
        {
            label: 'Recents',
            value: 'recent',
        },
        {
            label: 'Keypad',
            value: 'keypad',
        },
        {
            label: 'Voicemail',
            value: 'voicemail',
        }
    ]
    const [phoneNumber, setPhoneNumber] = useState('')
    const [vendorName, setVendorName] = useState('')
    const [callerId, setCallerId] = useState('')
    const [dialerShowClass, setDialerShowClass] = useState('')
    const [isMute, setIsMute] = useState(false)
    const [isPause, setIsPause] = useState(false)
    const [isCallDialed, setIsCallDialed] = useState(false)
    const [callerSID, setCallerSID] = useState('')
    const [countryCode, setCountryCode] = useState(1)
    const [outGoingCall, setOutGoingCall] = useState(null)
    const [duration, setDuration] = useState(0);
    const [durationInSec, setDurationInSec] = useState(0);
    const [currentTab, setCurrentTab] = useState('keypad')
    const [recentCalls, setRecentCalls] = useState([])
    const [voicemails, setVoicemails] = useState([])
    const [showVoicemailModal, setShowVoicemailModal] = useState(false)
    const [selectedVoicemail, setSelectedVoicemail] = useState({})
    const [voicemailAudioLink, setVoicemailAudioLink] = useState('')
    const [isLoadingVoicemail, setIsLoadingVoicemail] = React.useState(false)
    const [showLinkToVendorModal, setShowLinkToVendorModal] = useState(false)
    const [vendorToLink, setVendorToLink] = useState(null)
    const [showShareVoicemail, setShowShareVoicemail] = useState(false)
    const [shareVoicemailId, setShareVoicemailId] = useState(null)
    const [isMaximized, setIsMaximized] = useState(true)
    const [backdrop, setBackdrop] = useState('static')
    const [dialerHeight, setDialerHeight] = useState(660)

    useEffect(() => {
        if (supPhoneNumber) {
            setPhoneNumber(supPhoneNumber)
            onDialpadClick()
            removeSupPhoneNumber()
        }
    }, [supPhoneNumber])

    useEffect(() => {
        const element = document.getElementById('dialer-component')
        if (element) {
            setDialerHeight(element.scrollHeight)
        }
        const param1 = window.location.href.split('lists/insequence')[1]
        if (vendorData?.vendorsInCall?.callerAssigned) {
            dispatch(getRecentCallsAndVoicemails(vendorData?.vendorsInCall?.callerAssigned)).then(async (res) => {
                setRecentCalls(res?.recentCalls)
                setVoicemails(res?.voicemails)
                if (param1 && param1.includes('addcallerdetails')) {
                    let vendorId = param1.split('/addcallerdetails/')[1]
                    if (vendorId.includes('voicemailId')) {
                        var voicemailId = vendorId.split('=')[1]
                        let voicemail = res?.voicemails?.find(data => data?.callSid === voicemailId)
                        setCurrentTab('voicemail')
                        setShowVoicemailModal(true)
                        setSelectedVoicemail(voicemail)
                        if (voicemail && voicemail?.callTranscriptionSid) {
                            setIsLoadingVoicemail(true)
                            await dispatch(getMediaData(voicemail?.callTranscriptionSid))
                                .then(res => {
                                    console.log("res getMediaData", res)
                                    setVoicemailAudioLink(res?.media_url)
                                    setIsLoadingVoicemail(false)
                                }).catch(err => {
                                    setVoicemailAudioLink('')
                                    setIsLoadingVoicemail(false)
                                })
                        }
                    }

                }
            }).catch((err) => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to get recent calls!'
                })
            })
        }

    }, [vendorData?.vendorsInCall?.callerAssigned])

    useEffect(() => {
        let phoneNo = '1 ' + (vendorData?.phone || '')
        setPhoneNumber(phoneNo)
        setVendorName(vendorData?.suppliername)
        setCallerSID(callSID)
    }, [vendorData])

    useEffect(() => {
        setDialerShowClass(dialerClass)
        setIsCallDialed(isCallDial)
        setOutGoingCall(call)
    }, [isCallDial, dialerClass])

    const handleNumberClick = (value) => {
        if (isCallDialed) {
            var connections = twilioDevice.activeConnection();
            if (connections) {
                connections.sendDigits(value);
            }
            return
        }
        let phoneValue = phoneNumber
        if (!phoneValue || phoneValue === '') {
            value = countryCode + ' ' + value
        } else if (phoneValue === countryCode) {
            phoneValue = phoneValue + ' '
        }

        let number = phoneValue + value
        setPhoneNumber(number)
    }

    const handleCallStart = () => {
        if (user?.isCaller && user?.assignedPhoneNumber && !twilioDevice) {
            toast.show({
                title: 'Warning',
                description: 'Twilio device not registered. Please refresh the page or login again to register twilio device!'
            })
            return
        }
        if (!user?.isCaller && !user?.assignedPhoneNumber) {
            toast.show({
                title: 'Warning',
                description: 'You are not a caller!'
            })
            return
        }

        var phoneValue = phoneNumber ? '+' + phoneNumber : phoneNumber
        const phone = parsePhoneNumber(phoneValue);
        const isValid = phone?.valid || false
        var testPhone = phoneNumber?.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '')?.replace(/[^\w\s]|[\s]/gi, '')

        if (!isValid) {
            toast.show({
                title: 'Warning',
                description: 'Please enter valid phone number!'
            })
            return
        } else if (!testPhone || testPhone === countryCode) {
            toast.show({
                title: 'Warning',
                description: 'Please enter phone number!'
            })
            return
        }
        onCallStartClick(phoneNumber)
    }

    const handleCallEnd = () => {
        if (outGoingCall) {
            outGoingCall.disconnect();
            onCallEndClick()
            setDuration(0)
            setDurationInSec(0)
            onDialpadClick(null, true)
            dispatch(getRecentCallsAndVoicemails(vendorData?.vendorsInCall?.callerAssigned)).then(res => {
                setRecentCalls(res?.recentCalls)
                setVoicemails(res?.voicemails)
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to get recent calls!'
                })
            })
        }
    }

    const handlePhoneInputChange = (value, country, e, formattedValue) => {
        if (e.target.nodeName === 'SPAN') {
            setCountryCode(country.dialCode)
            setPhoneNumber(country?.dialCode)
            return
        }
        var phoneValue = formattedValue?.replace(/^\s*(?:\+?(\d{1,4}))\s?/, '').replace(/[^\w\s]|[\s]/gi, '')
        var countrycode = country?.dialCode + ' '
        if (phoneValue !== '') {
            phoneValue = countrycode + phoneValue
        } else {
            phoneValue = country.dialCode
        }
        setCountryCode(country.dialCode)
        setPhoneNumber(phoneValue === '' ? '' : phoneValue)
    }

    const handleMuteClick = () => {
        if (outGoingCall) {
            setIsMute(!isMute)
            if (isMute) {
                outGoingCall.mute(false);
            } else {
                outGoingCall.mute(true);
            }
        }
    }

    useEffect(() => {
        if (callStartTime) {
            const intervalId = setInterval(() => {
                const elapsedMilliseconds = Date.now() - callStartTime;
                const totalSeconds = Math.floor(elapsedMilliseconds / 1000);
                const minutes = Math.floor(totalSeconds / 60);
                const seconds = totalSeconds % 60;
                setDurationInSec(totalSeconds)
                setDuration({ minutes: minutes < 10 ? '0' + minutes : minutes, seconds: seconds < 10 ? '0' + seconds : seconds });
            }, 1000);

            return () => {
                clearInterval(intervalId);
            };
        }
    }, [callStartTime]);

    const handleHoldClick = () => {
        if (isPause) {
            dispatch(unholdCall())
        } else {
            dispatch(holdCall())
        }
        setIsPause(!isPause)
    }

    const handlePhoneDeleteClick = () => {
        var testPhone = phoneNumber.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
        if (parseInt(testPhone) !== countryCode) {
            let number = document.getElementById('phone-input-box').value = countryCode + ' ' + testPhone?.substr(0, testPhone.length - 1);
            setPhoneNumber(number)
        }
    }

    const handleClickTab = (tab) => {
        setCurrentTab(tab)
    }

    const handleVoicemailClick = async (voicemail) => {
        if (voicemail && voicemail?.callTranscriptionSid) {
            setIsLoadingVoicemail(true)
            await dispatch(getMediaData(voicemail?.callTranscriptionSid)).then(res => {
                setVoicemailAudioLink(res?.data?.media_url)
                setIsLoadingVoicemail(false)
            }).catch(() => {
                setVoicemailAudioLink('')
                setIsLoadingVoicemail(false)
            })
        } else if (voicemail?.isRecorded && voicemail?.callRecordingSid) {
            try {
                setIsLoadingVoicemail(true)
                const response = await dispatch(getRecordingUrl(voicemail?.callRecordingSid))
                const blobUrl = URL.createObjectURL(new Blob([response], { type: 'audio/mpeg' }))
                setVoicemailAudioLink(blobUrl)
                setIsLoadingVoicemail(false)
            } catch (err) {
                setIsLoadingVoicemail(false)
                if (err) {
                    toast.show({
                        title: 'Danger',
                        description: 'Unable To Get Recording Details'
                    })
                }
            }
        } else {
            setVoicemailAudioLink('')
            setIsLoadingVoicemail(false)
        }

        setSelectedVoicemail(voicemail)
        setShowVoicemailModal(true)
    }

    const getCallsHistoryHtml = () => {
        return <div className='call-histories d-flex'>
            {
                callHistoryTabs.map(tab => (
                    <div role='button' className={`d-flex flex-column align-items-center gap-2 ${tab.value}${currentTab === tab.value ? ' selected' : ''}`} onClick={() => { handleClickTab(tab.value) }}>
                        {
                            tab.value === 'recent' ?
                                <RxCounterClockwiseClock className='mt-2' color='#fff' size={30} />
                                : tab.value === 'keypad' ?
                                    <MdDialpad className='mt-2' color='#fff' size={30} />
                                    : <IoRecordingOutline className='mt-2' color='#fff' size={30} />
                        }
                        <h4 className='mb-2 text-white'>{tab.label}</h4>
                    </div>
                ))
            }
        </div>
    }

    const handleVoicemailCloseClick = () => {
        setVoicemailAudioLink('')
        setSelectedVoicemail({})
        setShowVoicemailModal(false)
        setShowLinkToVendorModal(false)
        setVendorToLink(null)
    }

    const handleLinkToSupplier = () => {
        setShowLinkToVendorModal(!showLinkToVendorModal)
    }

    const onChangeLinkToVendor = (vendorId) => {
        setVendorToLink(vendorId)
    }

    const handleOkClick = () => {
        if (!vendorToLink) {
            toast.show({
                title: 'Warning',
                description: 'Please select supplier to link!'
            })
            return
        }
        if (!selectedVoicemail?.callSid) {
            toast.show({
                title: 'Warning',
                description: 'No call sid linked to this voicemail!'
            })
            return
        }

        setIsLoadingVoicemail(true)
        dispatch(linkVoicemailToVendor(vendorToLink?.value, selectedVoicemail?.callSid, vendorId)).then(async (res) => {
            const voicemails = await dispatch(getVoicemails())
            toast.show({
                title: 'Success',
                description: res.message
            })
            handleVoicemailCloseClick()
            setVoicemails(voicemails || [])
            setIsLoadingVoicemail(false)
        }).catch(err => {
            toast.show({
                title: 'Warning',
                description: err.message
            })
            setIsLoadingVoicemail(false)
        })
    }

    const handleShareVoicemailClick = (e) => {
        setShowShareVoicemail(true)
        setShareVoicemailId(selectedVoicemail?.callSid)
    }

    const handleVoicemailShare = (notes) => {
        var userName = user?.firstname + (user?.lastname ? ' ' + user?.lastname : '')
        var editorContent = notes ? draftToHtml(convertToRaw(notes.getCurrentContent())) : '';
        var regex = /<a .*?>/g
        const emailsArray = [...editorContent.matchAll(regex)]
        var emails = []
        emailsArray && emailsArray.map((item) => {
            var hrefRegex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"/g
            var valueRegex = /<a\s+(?:[^>]*?\s+)?data-value="([^"]*)"/g
            const hrefArray = [...item[0].matchAll(hrefRegex)]
            const valueArray = [...item[0].matchAll(valueRegex)]
            if (hrefArray.length && valueArray.length) {
                const href = hrefArray?.[0]?.[1]
                const value = valueArray?.[0]?.[1]
                emails.push({ email: href.replaceAll('https://', ''), name: value.replaceAll('https://', '') })
            }
        })
        if (!emails || emails?.length === 0) {
            toast.show({
                title: 'Warning',
                description: 'Please add user email to share the call!',
            })
            return
        }

        dispatch(shareCall(
            editorContent,
            userName,
            emails,
            shareVoicemailId,
            vendorId,
            true
        )).then(() => {
            setShowShareVoicemail(false)
            setShareVoicemailId(null)
        }).catch(() => {
        })
    }

    const getCallTime = (startTime) => {
        var callTime = moment(startTime).format("hh:mm A")
        var isToday = moment(startTime).isSame(moment(), 'day');
        if (isToday) {
            callTime = 'Today: ' + callTime
        } else {
            callTime = moment(startTime).format("M/D: hh:mm A")
        }

        return callTime
    }

    const onMinimizeClick = () => {
        setIsMaximized(!isMaximized)
        setDialerShowClass('d-none');
        setBackdrop(false)
        document.getElementsByClassName('call-component dialer-component')?.[0].classList.add('call-monitor-modal-wrapper')
    }

    const onDialpadClick = (e = null, scrollToDialer = false) => {
        setDialerShowClass('');
        setCurrentTab('keypad')
        setIsMaximized(true);
        setBackdrop('static');
        document.getElementsByClassName('call-component dialer-component')?.[0].classList.remove('call-monitor-modal-wrapper');
        if ((e && e.isTrusted) || scrollToDialer) {
            document.getElementById("main-content").scrollTop = 0
        }
    }

    useEffect(() => {
        const mainElement = document.getElementById('main-content')
        let lastScrollTop =
            window.pageYOffset || mainElement.scrollTop;
        const handleScroll = e => {
            const element = document.getElementById('dialer-component')
            if (element) {
                var isScrollingDown = true
                const scrollTopPosition =
                    window.pageYOffset || mainElement.scrollTop;

                if (scrollTopPosition > lastScrollTop) {
                    isScrollingDown = true
                } else if (scrollTopPosition < lastScrollTop) {
                    isScrollingDown = false
                }
                lastScrollTop =
                    scrollTopPosition <= 0 ? 0 : scrollTopPosition;
                const scrollPosition = mainElement.scrollTop;
                const elementTop = element.scrollTop;
                const elementHeight = element.scrollHeight;
                const windowHeight = mainElement.offsetHeight;
                const isMinimizeDialer = scrollPosition >= elementHeight //(elementTop + elementHeight - windowHeight)
                const isMaximizeDialer = scrollPosition <= dialerHeight
                if (isMinimizeDialer && isCallDialed && isScrollingDown) {
                    // if (isScrollingDown) {
                    onMinimizeClick()
                    // } else {
                    //     onDialpadClick()
                    // }
                } else if (isMaximizeDialer && isCallDialed && !isScrollingDown) {
                    onDialpadClick()
                }
            }
        }
        if (mainElement) {
            mainElement.addEventListener('scroll', handleScroll)
            return () => {
                mainElement.removeEventListener("scroll", handleScroll)
            }
        }
    }, [isCallDialed])

    let phoneCode = phoneNumber ? phoneNumber.toString().match(/^\s*(?:\+?(\d{1,3}))?/gi)[0] : ''

    return (
        <div id='dialer-component' className={`call-component dialer-component position-relative rounded${isCallDialed ? ' dialed' : ''}`}>
            {isCallDialed && (
                <div className='maximize-area ms-auto p-2 d-flex align-items-center justify-content-end'>
                    {isMaximized
                        ? <CiMinimize1 role='button' color='#fff' size={26} onClick={() => { onMinimizeClick() }} />
                        : <CiMaximize1 role='button' color='#fff' size={26} onClick={(e) => { onDialpadClick(e) }} />
                    }
                </div>
            )}
            {isMaximized ? (
                currentTab === 'keypad' ? (
                    <>
                        <div className='call-comp[onent dialer-compondent p-5 bordder rounded d-flex flex-column align-items-center position-relative'>
                            <div className='p-3 rounded-circle bg-light-gray'><IoPersonSharp color="#fff" size={40} /></div>
                            <h4 className='text-center text-white mb-0 mt-3 fw-bold'>{vendorName}</h4>
                            <div className="phone-inut-parent flex align-center">
                                <div className='d-flex border-0 rounded border-dark phone-input-ext-container w-100 flex-column flex-lg-row align-items-center position-relative'>
                                    <ReactPhoneInput
                                        className='phone-input-parent'
                                        country={'us'}
                                        value={phoneNumber}
                                        onChange={handlePhoneInputChange}
                                        countryCodeEditable={false}
                                        preferredCountries={['us']}
                                        buttonClass='border-0 border-dark bg-transparent'
                                        inputProps={{
                                            className: 'form-control border-0 bg-transparent text-white shadow-none',
                                            id: 'phone-input-box'
                                        }}
                                    />
                                    <RiDeleteBack2Fill role="button" className='position-absolute end-0' color='#e50606' size={24} onClick={() => { handlePhoneDeleteClick() }} />
                                </div>
                            </div>
                            {isCallDialed && (
                                <>
                                    {duration ? (
                                        <p className='h4 call-timer text-white mb-0 mt-2'> {duration?.minutes} : {duration?.seconds}</p>
                                    ) : <></>}
                                    <div className='d-flex mt-3 justify-content-center align-items-center gap-5'>
                                        <div className={`p-2 rounded-circle ${isMute ? 'bg-light-gray' : ''}`}>
                                            <BsMicMuteFill color={`${isMute ? '#000' : '#fff'}`} size={25} onClick={() => { handleMuteClick() }} />
                                        </div>
                                        {isPause ?
                                            <AiOutlinePlayCircle color="#fff" size={25} onClick={() => { handleHoldClick() }} />
                                            :
                                            <AiOutlinePauseCircle color="#fff" size={25} onClick={() => { handleHoldClick() }} />
                                        }
                                        <MdDialpad color="#fff" size={25} onClick={() => { !dialerShowClass ? setDialerShowClass('d-none') : setDialerShowClass('') }} />
                                    </div>
                                </>
                            )}
                            <div className={`d-flex ps-5 pe-5 gap-4 flex-wrap justify-content-center ${dialerShowClass} ${isCallDialed ? 'mt-3' : 'mt-3'}`}>
                                {dialerNumbers.map(value => {
                                    return <input style={{ height: '50px', width: '50px' }} className='bg-light-gray text-blue fw-bold h4 mb-0 text-center border-0 rounded-circle' readOnly onClick={(event) => { handleNumberClick(event.target.value) }} value={value} />
                                })}
                            </div>
                        </div>
                        <div className='d-flex flex-column position-absolute bottom-0 start-0 end-0'>
                            <div className='call-buttons position-absdolute stadrt-0 endd-0 d-flex flex-column justify-content-center align-items-center gap-4'>
                                {status && (
                                    <h4 className='text-white'>Status: {status} </h4>
                                )}
                                <div className='call-buttons d-flex justify-content-center'>
                                    <button id="dial-call" onClick={() => { handleCallStart() }}><IoIosCall style={{ background: '#198754' }} className={`rounded-circle p-2 mb-3${isCallDialed ? ' d-none' : ''}`} color="#fff" size={50} /></button>
                                    <button id="cut-call" onClick={() => { handleCallEnd() }} ><MdCallEnd style={{ background: '#FF0000' }} className={`rounded-circle p-2 ms-4 mb-3${!isCallDialed ? ' d-none' : ''}`} color="#fff" size={50} /></button>
                                </div>
                            </div>
                            {!isCallDialed && (
                                getCallsHistoryHtml()
                            )}
                        </div>
                    </>
                ) :
                    <div className='call-history-content border border-start-0 border-end-0 border-bottom-0 border-top border-white mdt-4'>
                        {currentTab === 'recent' && (
                            <div className='recent-calls pt-5 no-scrollbar'>
                                {recentCalls?.length ? recentCalls?.map((call, ind) => {
                                    return <div id={ind} className={`d-flex gap-3 align-items-center border border-1 border-start-0 border-end-0 p-2${ind !== (recentCalls?.length - 1) ? ' border-bottom-0' : ''}`}>
                                        <IoPersonSharp className='p-2 rounded-circle bg-light-gray' color="#fff" size={30} />
                                        <div className='flex-grow-1 d-flex flex-column gap-2'>
                                            <h4 className='text-white mb-0'>{call?.callRecording?.listSupplier ? call?.callRecording?.listSupplier?.suppliername : 'Unknown'}</h4>
                                            <div className='d-flex gap-2 align-items-center'>
                                                {call?.callType === 'outbound' ?
                                                    <HiPhoneOutgoing className='rounded-circle' color="#198754" size={25} />
                                                    :
                                                    (call?.callType === 'inbound' && call?.callStatus === 'no-answer') ?
                                                        <HiPhoneMissedCall className='rounded-circle' color="#FF0000" size={25} />
                                                        :
                                                        <HiPhoneIncoming className='rounded-circle' color="#29ABE2" size={25} />
                                                }
                                                <h4 className='text-white mb-0'>{call?.externalNumber}</h4>
                                            </div>
                                        </div>
                                        <p className='call-time mb-0 text-white me-2 text-end'>{getCallTime(call?.startTime)}</p>
                                    </div>
                                }) :
                                    <h4 className='mb-0 ms-3 text-white'> No Recent Calls found </h4>
                                }
                            </div>
                        )}
                        {currentTab === 'voicemail' && (
                            <div className='voicemails pt-5 no-scrollbar position-relative'>
                                {voicemails?.length ? voicemails?.map((voicemail, ind) => (
                                    <div id={ind} className={`d-flex gap-3 align-items-center border border-1 border-start-0 border-end-0 p-2${ind !== (voicemails?.length - 1) ? ' border-bottom-0' : ''}`}>
                                        <IoPersonSharp className='p-2 rounded-circle bg-light-gray' color="#fff" size={30} />
                                        <div className='flex-grow-1 d-flex flex-column '>
                                            <h4 className='text-white mb-0'>{voicemail?.listSupplier ? voicemail?.listSupplier?.suppliername : 'Unknown'}</h4>
                                            <h4 className='text-white mb-0 mt-1'>{voicemail?.callDetail?.externalNumber}</h4>
                                        </div>
                                        <p className='m-0 fs-5 text-white'>{getCallTime(voicemail?.callStartTime)}</p>
                                        <BsInfoCircle className='me-4' color='#fff' size={24} onClick={() => { handleVoicemailClick(voicemail) }} />
                                    </div>
                                )) :
                                    <h4 className='mb-0 ms-3 text-white'> No Voicecalls found </h4>
                                }

                            </div>
                        )}
                        {showVoicemailModal && (
                            <div className={`voicemail-content d-flex flex-column gap-4 position-absolute p-3 bg-white ${showVoicemailModal ? 'd-block' : 'd-none'}`}>
                                <AiOutlineCloseCircle type='button' className='text-black ms-auto' size={20} onClick={handleVoicemailCloseClick} />
                                <div className={`d-flex gap-3 justify-content-center align-items-center`}>
                                    <IoPersonSharp color="#000" size={30} />
                                    <div className='d-flex flex-column gap-1'>
                                        <div className='d-flex gap-3 align-items-center'>
                                            <h4 className='text-black mb-0'>{selectedVoicemail?.listSupplier?.suppliername || 'Unknown'}</h4>
                                            {selectedVoicemail?.listSupplierId ?
                                                <FiLink2 className='ms-auto' color="#198754" size={20} />
                                                :
                                                <BiUnlink className='ms-auto' color="#FF0000" size={20} />
                                            }
                                        </div>
                                        <div className='d-flex gap-3 align-items-center'>
                                            <h4 className='text-black mb-0'>{selectedVoicemail?.callDetail?.externalNumber || ''}</h4>
                                            <p className='mb-0 text-black ms-auto'>
                                                {getCallTime(selectedVoicemail?.callStartTime)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className={`p-4 pb-0 position-relative${isLoadingVoicemail ? ' loading' : ''}`}>
                                    {isLoadingVoicemail && <Loader center={true} size='md' />}
                                    <AudioPlayer
                                        showJumpControls={false}
                                        autoPlayAfterSrcChange={false}
                                        src={voicemailAudioLink}
                                    />
                                    <div className='position-absolute d-flex voicemail-additional-buttons'>
                                        <FiShare type='button' onClick={() => { handleShareVoicemailClick() }} color='#214466' className='ms-hauto' size={25} />
                                    </div>
                                </div>
                                {!selectedVoicemail?.listSupplierId && (
                                    <>
                                        <button className='rounded btn-green w-50 p-2 h4 mb-0 ms-auto me-auto' onClick={handleLinkToSupplier}>Link to supplier</button>
                                        {showLinkToVendorModal && (
                                            <div className='link-to-vendor-container'>
                                                <h4 className='text-black fw-bold'>Select supplier:</h4>
                                                <Select
                                                    className="link-voicemail-options h4 mb-0"
                                                    options={callsTableData?.map((option) => {
                                                        return {
                                                            label: option?.suppliername,
                                                            value: option?.id
                                                        }
                                                    })}
                                                    value={vendorToLink}
                                                    onChange={(vendor) => { onChangeLinkToVendor(vendor) }}
                                                />

                                                <div className='d-flex justify-content-end mt-3'>
                                                    <button
                                                        type="button"
                                                        className="me-3 h4 mb-0 pt-2 pb-2 bg-gray text-white width-100 rounded"
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="h4 mb-0 pt-2 pb-2 btn-green width-100 rounded"
                                                        onClick={() => handleOkClick()}
                                                    >
                                                        Ok
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                        <div className='d-flex flex-column position-absolute bottom-0 start-0 end-0'>
                            {getCallsHistoryHtml()}
                        </div>
                    </div>
            ) : (
                <div className='minimize-dialer-parent p-3 d-flex flex-column'>
                    <div className='d-flex align-items-center'>
                        <div>
                            <h5 className='text-white mb-0 mt-3 fw-bold'>{vendorName}</h5>
                            <h5 className='text-white mb-0 mt-3 fw-bold'>{phoneCode?.toString()?.trim() === phoneNumber?.toString()?.trim() ? '' : phoneNumber}</h5>
                        </div>
                        <div className='ms-auto'>
                            <button id="cut-call" onClick={() => { handleCallEnd() }} ><MdCallEnd style={{ background: '#FF0000' }} className={`rounded-circle p-2 ms-4 mb-3`} color="#fff" size={40} /></button>
                        </div>
                    </div>
                    <div className='d-flex align-items-center mt-s2 mt-auto'>
                        <div className='d-flex gap-2'>
                            <BsSoundwave size={25} color='#fff' />
                            {duration ? (
                                <p className='h4 call-timer text-white mb-0 mt-2'>{duration?.minutes} : {duration?.seconds}</p>
                            ) : <p className='h4 call-timer text-white mb-0 mt-2'>{status}</p>}
                        </div>
                        <div className='d-flex align-items-center ms-auto'>
                            <div className={`p-2 rounded-circle ${isMute ? 'bg-light-gray' : ''}`}>
                                <BsMicMuteFill role='button' color={`${isMute ? 'red' : '#fff'}`} size={25} onClick={() => { handleMuteClick() }} />
                            </div>
                            <MdDialpad role='button' color="#fff" size={25} onClick={(e) => { onDialpadClick(e) }} />
                        </div>
                    </div>
                </div>
            )}

            <QaNotesModal
                show={showShareVoicemail}
                onClose={() => { setShowShareVoicemail(false) }}
                onDone={handleVoicemailShare}
                title='Share Voicemail'
                size='md'
                isShareCallModal={true}
            />
        </div>
    )
}

export default DialerComponent